import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/more_vert_black_24dp.png'
import _imports_1 from '@/assets/icons/resend_invite_20px@2x.png'
import _imports_2 from '@/assets/icons/clear_results_20px@2x.png'
import _imports_3 from '@/assets/icons/delete_20px@2x.png'
import _imports_4 from '@/assets/icons/navigate_right_32px.png'


const _withScopeId = n => (_pushScopeId("data-v-bc526488"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-normal table-assessments" }
const _hoisted_2 = { class: "table-container" }
const _hoisted_3 = { class: "table-header-container" }
const _hoisted_4 = { class: "table-header" }
const _hoisted_5 = { class: "table-data candidates center" }
const _hoisted_6 = { class: "arrow-sorting" }
const _hoisted_7 = { class: "table-data joined center" }
const _hoisted_8 = { class: "arrow-sorting" }
const _hoisted_9 = { class: "table-data score flex-mid" }
const _hoisted_10 = { class: "arrow-sorting" }
const _hoisted_11 = { class: "table-data status center" }
const _hoisted_12 = { class: "arrow-sorting" }
const _hoisted_13 = { class: "table-data your-rating center" }
const _hoisted_14 = { class: "arrow-sorting" }
const _hoisted_15 = { class: "table-data action" }
const _hoisted_16 = { class: "table-body-container" }
const _hoisted_17 = { class: "table-data candidates ellipsis fs-16 fw-700" }
const _hoisted_18 = { class: "table-data joined fs-16 ellipsis" }
const _hoisted_19 = { class: "table-data score center ellipsis" }
const _hoisted_20 = { class: "table-data status" }
const _hoisted_21 = { class: "table-data your-rating" }
const _hoisted_22 = { class: "flex-center" }
const _hoisted_23 = { class: "table-data action" }
const _hoisted_24 = { class: "flex-center" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "el-dropdown-link" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer p-10 ml-12" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "icons_more_vert_black_24dp",
      class: "icon-24"
    })
  ])
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-12 flex-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "icon-20",
    alt: "Re-send Invite"
  })
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-12 flex-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "icon-20",
    alt: "email_24px"
  })
], -1))
const _hoisted_28 = { class: "menu-dropdown flex-center" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-12 flex-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "icon-20",
    alt: "delete_20px"
  })
], -1))
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "icon-32",
  alt: "icons_navigate_right_32px"
}, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 1,
  class: "p-6 flex-mid ml-24 icon-hover-right opa-03"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "icon-32",
  alt: "icons_navigate_right_32px"
}, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 0,
  class: "fs-16 fw-500 pt-52 pb-52 m-52"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("headerTable.CANDIDATES")), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fillterValue = 'candidate_ascending')),
                  class: _normalizeClass([`${_ctx.filterActiveClass('candidate_ascending')}`, "arrow arrow-top"])
                }, " ▲ ", 2),
                _createElementVNode("div", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fillterValue = 'candidate_descending')),
                  class: _normalizeClass([`${_ctx.filterActiveClass('candidate_descending')}`, "arrow arrow-down"])
                }, " ▲ ", 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("headerTable.JOINED")), 1),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fillterValue = 'joined_ascending')),
                  class: _normalizeClass([`${_ctx.filterActiveClass('joined_ascending')}`, "arrow arrow-top"])
                }, " ▲ ", 2),
                _createElementVNode("div", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.fillterValue = 'joined_descending')),
                  class: _normalizeClass([`${_ctx.filterActiveClass('joined_descending')}`, "arrow arrow-down"])
                }, " ▲ ", 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("headerTable.SCORE")), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fillterValue = 'score_ascending')),
                  class: _normalizeClass([`${_ctx.filterActiveClass('score_ascending')}`, "arrow arrow-top"])
                }, " ▲ ", 2),
                _createElementVNode("div", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.fillterValue = 'score_descending')),
                  class: _normalizeClass([`${_ctx.filterActiveClass('score_descending')}`, "arrow arrow-down"])
                }, " ▲ ", 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("headerTable.STATUS")), 1),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fillterValue = 'status_ascending')),
                  class: _normalizeClass([`${_ctx.filterActiveClass('status_ascending')}`, "arrow arrow-top"])
                }, " ▲ ", 2),
                _createElementVNode("div", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.fillterValue = 'status_descending')),
                  class: _normalizeClass([`${_ctx.filterActiveClass('status_descending')}`, "arrow arrow-down"])
                }, " ▲ ", 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("headerTable.YOUR_RATING")), 1),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.fillterValue = 'rating_ascending')),
                  class: _normalizeClass([`${_ctx.filterActiveClass('rating_ascending')}`, "arrow arrow-top"])
                }, " ▲ ", 2),
                _createElementVNode("div", {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.fillterValue = 'rating_descending')),
                  class: _normalizeClass([`${_ctx.filterActiveClass('rating_descending')}`, "arrow arrow-down"])
                }, " ▲ ", 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("headerTable.ACTIONS")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataFiltered, (data, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "table-body fs-16",
              key: index + '_table-assessments'
            }, [
              _createElementVNode("div", _hoisted_17, _toDisplayString(data.display_name), 1),
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.format(data.joined_at)), 1),
              _createElementVNode("div", _hoisted_19, _toDisplayString(/*data.score != "0" ?*/ Math.round(data.score) + "%" /* : "-" */), 1),
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.status(data.status)), 1),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_el_rate, {
                    modelValue: data.rating,
                    "onUpdate:modelValue": ($event: any) => ((data.rating) = $event),
                    onClick: ($event: any) => (_ctx.onClickRating(data)),
                    colors: [_ctx.companyColor, _ctx.companyColor, _ctx.companyColor]
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick", "colors"])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_el_dropdown, null, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_dropdown_item, {
                            onClick: 
                        (event) => {
                          _ctx.handleCommand('resend', data, event);
                        }
                      
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["menu-dropdown flex-center", `${_ctx.reSendInviteCls(data)}`])
                              }, [
                                _hoisted_26,
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t("btn.Re_send_Invit")), 1)
                              ], 2)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_el_dropdown_item, {
                            onClick: 
                        (event) => {
                          _ctx.handleCommand('reset', data, event);
                        }
                      
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["menu-dropdown flex-center", `${_ctx.clearResultsCls(data)}`])
                              }, [
                                _hoisted_27,
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t("btn.Clear_Results")), 1)
                              ], 2)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_el_dropdown_item, {
                            onClick: ($event: any) => (_ctx.handleCommand('delete', data))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_28, [
                                _hoisted_29,
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t("btn.Remove")), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _hoisted_25
                    ]),
                    _: 2
                  }, 1024),
                  (data.status == 'COMPLETED')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.assessmentsCandidate(data)),
                        class: "p-6 cursor-pointer flex-mid ml-24 icon-hover-right"
                      }, _hoisted_32, 8, _hoisted_30))
                    : (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createTextVNode(_toDisplayString(_ctx.$t("assessments.Get_started")) + " ", 1),
          _createElementVNode("span", {
            class: "fc-primary cursor-pointer text-underline",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (
        _ctx.$router.push({ name: 'AssessmentsCreate', params: { step: 'name' } })
      ))
          }, _toDisplayString(_ctx.$t("assessments.by_creating_a_new")), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}